<template>
  <span
    class="numberScrolling"
    v-text="`${_valFormatHandler(val, unit)}`"
  ></span>
</template>

<script>
// 目前只支持大于等于0的数字滚动
export default {
  name: 'NumberScrolling',
  props: {
    tarVal: {
      type: [Number, String],
      default: 0,
    },
    animationTotalTime: {
      // 单位毫秒
      type: Number,
      default: 600,
    },
    unit: {
      type: String,
      default: '',
    },
  },
  watch: {
    tarVal: {
      handler(newValue, oldValue) {
        console.debug('numberScrolling:', newValue)
        if (JSON.stringify(newValue) != JSON.stringify(oldValue)) {
          this.clearIntervalEvent()
          if (newValue === null || isNaN(newValue) || newValue - 0 < 0) {
            // 不是数或者负数，直接赋值
            this.val = newValue
          } else {
            // 无论是数字还是字符串，一律转成字符串先处理是否有小数的问题
            let toFixedNum = 0
            let newValueString = newValue.toString()
            if (newValueString.indexOf('.') > -1) {
              const newValueArr = newValueString.split('.')
              toFixedNum = newValueArr[1].length
            }
            this.toFixedNum = toFixedNum
            // const tarVal = Number(newValue)
            // if (parseInt(tarVal) === parseFloat(tarVal)) {
            //   // 大概率是整数，但是20.0这种情况他们也相等,这种情况也可以认为是整数
            //   this.toFixedNum = toFixedNum
            // } else {
            //   // 是小数
            //   this.toFixedNum = toFixedNum
            // }
            this.changeNumHandler(
              isNaN(oldValue) ? 0 : Number(oldValue),
              Number(newValue)
            )
          }
        }
      },
      immediate: true,
    },
  },
  data() {
    return {
      val: null,
      amoutIntervalId: null,
      toFixedNum: 1, //如果出现小数，默认保留1位
    }
  },

  methods: {
    changeNumHandler(orgVal, tarVal) {
      let i = 0
      const changeTotalNum = 20
      const refreshTime = Math.floor(this.animationTotalTime / changeTotalNum)
      const diffVal = Number(Math.abs(tarVal - orgVal).toFixed(this.toFixedNum))
      const ceilVal = Math.floor(diffVal / changeTotalNum)
      let type = ''
      // console.debug('ceilVal:', ceilVal, diffVal)

      if (orgVal > tarVal) {
        // 数变小
        type = 'dec'
      } else {
        // 数变大
        type = 'inc'
      }
      if (ceilVal > 0) {
        // 够平分的
        this.amoutIntervalId = setInterval(() => {
          if (i < changeTotalNum) {
            i++
            if (type === 'inc') {
              this.val = (orgVal + i * ceilVal).toFixed(this.toFixedNum)
            } else {
              this.val = (orgVal - i * ceilVal).toFixed(this.toFixedNum)
            }
          } else {
            this.val = tarVal.toFixed(this.toFixedNum)
            this.clearIntervalEvent()
          }
        }, refreshTime)
      } else {
        // 不够平分的
        let val = orgVal
        let totalChangeVal = 0
        let everyChangeVal = 1
        let total = 0
        if (diffVal >= 1) {
          // 大于等于1就每次加1
        } else {
          // 在0~1之间，证明tarVal应该就带小数
          everyChangeVal = 0.1
        }
        this.amoutIntervalId = setInterval(() => {
          totalChangeVal = totalChangeVal + everyChangeVal
          if (type === 'inc') {
            total = val + totalChangeVal
            if (total < tarVal) {
              this.val = total.toFixed(this.toFixedNum)
            } else {
              this.val = tarVal.toFixed(this.toFixedNum)
              this.clearIntervalEvent()
            }
          } else {
            total = val - totalChangeVal
            if (total > tarVal) {
              this.val = total.toFixed(this.toFixedNum)
            } else {
              this.val = tarVal.toFixed(this.toFixedNum)
              this.clearIntervalEvent()
            }
          }

          // console.debug(this.val)
        }, refreshTime)
      }
    },
    clearIntervalEvent() {
      if (this.amoutIntervalId) {
        clearInterval(this.amoutIntervalId)
        this.amoutIntervalId = null
      }
    },
    _valFormatHandler(val, ceil) {
      let data
      // console.debug('_valFormatHandler:', val, typeof val, ceil)
      if (val === undefined || val === null || val === '' || val === ' ') {
        data = '-'
      } else {
        if (val && ceil) {
          data = `${val}${ceil ? ceil : ''}`
        } else {
          data = val
        }
      }
      // console.debug('_valFormatHandler:', val, data)
      return data
    },
  },
}
</script>
